<template>
  <div
    id="signage-launcher-module"
    :class="{ active: entranceConfig.signage.list.length }"
    @click="consult()">
    <div class="launcher-module-header">
      <app-icon
        name="signage"
        size="tiny"
        :color="entranceConfig.signage.list.length ? '#f69898' : '#bdbdbd'" />
        <span>Signalétique</span>
    </div>
    <template v-if="!entranceConfig.signage.list.length">
      <div id="empty-template">
        - Aucune donnée -
      </div>
    </template>
    <template v-else>
      <div id="signage-content">
        <div id="content-list" :class="{ large : entranceConfig.signage.list.length > 6 }">
          <div
            class="signage-list-item"
            v-for="(item, index) in signageList"
            :key="index">
            &#8226;<span>{{ item.name_to_display }}</span>
          </div>
          <div class="signage-list-item" v-if="entranceConfig.signage.list.length > 11">
            &#8226;
            <span>
              et {{ entranceConfig.signage.list.length - signageList.length }}
              autre{{ entranceConfig.signage.list.length - signageList.length > 1 ? 's' : '' }}
            </span>
          </div>
        </div>
        <p>
          On est perdu ? Pas d’inquiétude, cliquez ici et retrouvez votre chemin
        </p>
        <app-icon
          id="touch"
          name="touch"
          size="normal"
          color="#f69898" />
      </div>
    </template>
  </div>
</template>

<style lang="sass">
#signage-launcher-module
  .launcher-module-header
    border-top-color: #bdbdbd
    span
      color: #bdbdbd
  &.active
    .launcher-module-header
      border-top-color: #f69898
      span
        color: #f69898
#empty-template
  color: #9e9e9e
  display: flex
  justify-content: center
  font-family: 'RobotoLightItalic'
  font-size: .9em
  margin-top: 2rem
#signage-content
  align-items: flex-start
  display: flex
  flex-direction: column
  height: 87%
  justify-content: space-between
  padding: 0 1.3rem
  #content-list
    display: flex
    flex-direction: column
    height: 65%
    justify-content: center
    overflow: hidden
    padding: 0 .7rem
    position: absolute
    width: 90%
    &.large
      align-content: flex-start
      flex-direction: row
      flex-wrap: wrap
      justify-content: flex-start
      margin-top: .7rem
      .signage-list-item
        width: 48%
        span
          font-size: .72em
          width: 80%
    .signage-list-item
      align-items: center
      color: #f69898
      display: flex
      font-size: 1.1em
      line-height: 3rem
      span
        background: -webkit-linear-gradient(30deg, #424242 75%, transparent)
        color: #424242
        font-family: 'RobotoRegular'
        font-size: .75em
        margin-left: .8rem
        width: 98%
        white-space: nowrap
        -webkit-background-clip: text
        -webkit-text-fill-color: transparent
  p
    bottom: 1.5rem
    color: #707070
    font-family: "RobotoLightItalic"
    font-size: .63em
    margin: 0
    position: absolute
    text-align: justify
    width: 65%
  #touch
    bottom: 1.3rem
    position: absolute
    right: 1rem
</style>

<script>
import AppIcon from '@/components/icons/AppIcon.vue';

export default {
  name: 'SignageModule',

  components: {
    AppIcon,
  },

  props: {
    config: Object,
    entranceConfig: Object,
  },

  computed: {
    signageList() {
      let list = [];

      for (let i = 0; i < this.entranceConfig.signage.list.length; i++) {
        const element = this.entranceConfig.signage.list[i];
        
        if (i < 11) {
          list.push(element);
        }
      }
      return list;
    },
  },

  methods: {
    consult() {
      if (this.entranceConfig.signage.list.length) {
        this.$router.push({ name: 'signagePage' });
      }
    },
  },
};
</script>